var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.34429 28.8198H0.531788V10.1323H6.34429V28.8198ZM3.40679 7.63232C1.59429 7.63232 0.0942879 6.06982 0.0942879 4.19482C0.0942879 2.38232 1.59429 0.882324 3.40679 0.882324C5.28179 0.882324 6.78179 2.38232 6.78179 4.19482C6.78179 6.06982 5.28179 7.63232 3.40679 7.63232ZM28.0318 28.8198H22.2818V19.7573C22.2818 17.5698 22.2193 14.8198 19.2193 14.8198C16.2193 14.8198 15.7818 17.1323 15.7818 19.5698V28.8198H9.96929V10.1323H15.5318V12.6948H15.5943C16.4068 11.2573 18.2818 9.69482 21.0943 9.69482C26.9693 9.69482 28.0943 13.5698 28.0943 18.5698V28.8198H28.0318Z",
    fill: "#22242B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.92e6c6e5ae14aa93e7a1dba89752660d.svg";
export { ForwardRef as ReactComponent };